import { useEffect } from "react";
import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { TextField } from "@mui/material";
import { useUpdateStatus } from "./hooks/useUpdateStatus";

export type UpdateStatusProps = {
    onConfirm: (data: any) => void;
    onClose: () => void;
    open: boolean;
    title: string;
	row: object;
	type: string;
} & DefaultComponentProps;

export const UpdateStatusDialog = ({ onConfirm, onClose, open, title, row, type }: UpdateStatusProps) => {
    const { form, onHandleChange, createForm } = useUpdateStatus(open)

	useEffect(() => {
		if(Object.keys(row).length > 0){
			createForm(row, type)
		}
		 // eslint-disable-next-line react-hooks/exhaustive-deps
	 }, [row])

    return (
        <Dialog onClose={onClose} open={open}>
			<DialogTitle>
				<Typography variant="h2">{title}</Typography>
			</DialogTitle>
			<DialogContent>
				<TextField value={form?.updates?.expired_date?.slice(0, 16) || new Date().toJSON().slice(0, 16)} onInput={onHandleChange.bind(this)} InputLabelProps={{ shrink: true }} type={"datetime-local"} style={{ cursor: "pointer" }} color="secondary" label="Fecha expiración" />
			</DialogContent>

			<DialogActions>
				<FlexGrid container fullHeight fullWidth justify='space-between' alignItems='flex-end' style={{ marginTop: '20px' }}>
					<FlexGrid item>
						<Button onClick={onClose} buttonType='secondary' size='normal'>
							Cancelar
						</Button>
					</FlexGrid>
					<FlexGrid item>
						<Button onClick={() => onConfirm(form)} size='normal'>
							Aceptar
						</Button>
					</FlexGrid>
				</FlexGrid>
			</DialogActions>
        </Dialog>
    )
}